// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__16Zj3","buttons":"SendReceipts_buttons__2_SYL","email":"SendReceipts_email__oenGU","bookApptTitle":"SendReceipts_bookApptTitle__1s-WM"};